import React, { FC } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { useFormikContext } from "formik";
import { getFormattedTime, getTime } from "../../../services/utilities/dateFormatting";

interface SummaryProps {
    onBack: (event: any) => void;
}

const Summary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <span className={`mb-3 text-portal-blue-primary text-xl font-semibold`}>
            {translate.byKey(TranslationKeys.summary)}
        </span>
        <div className="flex flex-col">
            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.filter)}: <span className="text-sm text-black">{translate.byKey(TranslationKeys.timeFilter)}</span></h4>
            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.time)}: <span className="text-sm text-black">{getFormattedTime(getTime(values.time))}</span></h4>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type='submit'>{translate.byKey(TranslationKeys.submit)}</button>
            </div>
        </div>
    </div>
}

export default Summary;